import React from 'react';

import * as styles from './ActiveSortLabel.module.scss';

export interface ActiveSortLabelProps {
  isVisible: boolean;
  label: string;
}

const ActiveSortLabel: React.FC<ActiveSortLabelProps> = (props) => {
  const { isVisible, label } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <div data-test-id="activeSortLabel" className={styles.ActiveSortLabel__label}>
      {label}
    </div>
  );
};

export default ActiveSortLabel;
